var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVisionPicking = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#BAD5DB",
  d: "M18.6 22.4H3V10.9c0-.4.3-.7.7-.7h14.2c.4 0 .7.3.7.7v4.4c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-4.1H4v10.2h13.6v-.3c0-.3.2-.5.5-.5s.5.2.5.5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BAD5DB",
  d: "M3.5 11.2c-.1 0-.2 0-.3-.1-.2-.2-.2-.5-.1-.7l2.3-3.2h2c.3 0 .5.2.5.5s-.3.5-.6.5H5.9l-2 2.8c-.1.1-.2.2-.4.2M18.1 11.2c-.2 0-.3-.1-.4-.2l-2-2.8h-1.4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2l2.3 3.2c.2.2.1.5-.1.7-.2.1-.3.1-.4.1"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M10.8 9.1c-.3 0-.5-.2-.5-.5V4.1c0-.3.2-.5.5-.5s.5.2.5.5v4.6c0 .2-.2.4-.5.4"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M10.8 9.8 8.6 7.7c-.2-.2-.2-.5 0-.7s.5-.2.7 0l1.4 1.4L12.3 7c.2-.2.5-.2.7 0s.2.5 0 .7z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#3FE7E7",
  d: "M14.1 13.9H7.2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h6.9c.3 0 .5.2.5.5s-.2.5-.5.5"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#00CFB3",
  d: "M18.1 21.6c-1.8 0-3.6-1.1-4.8-2.9q-.3-.45 0-.9c1.3-1.9 3-2.9 4.8-2.9s3.6 1.1 4.8 2.9q.3.45 0 .9c-1.2 1.8-3 2.9-4.8 2.9m-3.9-3.3c1 1.5 2.4 2.3 3.9 2.3s2.9-.9 3.9-2.3c-.8-1.1-2.2-2.3-3.9-2.3-1.4-.1-2.8.8-3.9 2.3m7.8-.1"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#00CFB3",
  d: "M18.1 19.9c-.9 0-1.7-.7-1.7-1.7 0-.9.7-1.7 1.7-1.7.9 0 1.7.7 1.7 1.7-.1.9-.8 1.7-1.7 1.7m0-2.3c-.4 0-.7.3-.7.7s.3.7.7.7.7-.3.7-.7c-.1-.5-.4-.7-.7-.7"
})));
export default SvgVisionPicking;